// extracted by mini-css-extract-plugin
export default {"linkWrapper":"_mfmF","modelTitle":"cgoXB"};